import { render, staticRenderFns } from "./ViewLayoutIcon.vue?vue&type=template&id=45643974&"
import script from "./ViewLayoutIcon.vue?vue&type=script&lang=js&"
export * from "./ViewLayoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports